import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useCoaches = (params) => {
  const query = new URLSearchParams();
  if (params?.q) {
    query.set('q', params.q);
  }

  const urlStr = `${getApiUrl()}/mega/coach?${query.toString()}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};

export const useCoach = (id) => {
  const urlStr = `${getApiUrl()}/mega/coach/${id}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};
